import { brandLogos } from '@/data/content';

const maskStyle = {
  WebkitMaskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
  maskImage: 'linear-gradient(to right, transparent, black 8%, black 92%, transparent)',
};

export default function BrandMarquee({ compact = false }: { compact?: boolean }) {
  const track = (
    <div className="relative overflow-hidden" style={maskStyle}>
      <div className="flex w-max animate-marquee items-center gap-6 will-change-transform hover:[animation-play-state:paused]">
        {brandLogos.concat(brandLogos).map((brand, i) => (
          <div
            key={`${brand.name}-${i}`}
            aria-hidden={i >= brandLogos.length}
            className={`group flex h-24 w-52 flex-shrink-0 items-center justify-center rounded-2xl border border-slate-200 p-6 shadow-sm transition hover:-translate-y-1 hover:shadow-lg ${brand.dark ? 'bg-slate-900' : 'bg-white'}`}
          >
            <img
              src={brand.logo}
              alt={brand.name}
              className="h-12 w-auto max-w-full object-contain grayscale transition duration-300 group-hover:grayscale-0"
              loading="lazy"
            />
          </div>
        ))}
      </div>
    </div>
  );

  if (compact) {
    return (
      <section className="border-y border-slate-100 bg-white py-8" aria-label="Trusted brands">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <p className="mb-5 text-center text-xs font-bold uppercase tracking-wider text-slate-500">
            Trusted by teams at
          </p>
          {track}
        </div>
      </section>
    );
  }

  return (
    <section className="bg-slate-50 py-24" aria-labelledby="trusted-heading">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mb-14 text-center">
          <h2 id="trusted-heading" className="section-title">Trusted by real brands</h2>
          <p className="section-subtitle mx-auto max-w-2xl">
            Teams across fintech, health, logistics, and social impact use ZuriHub every day.
          </p>
        </div>
        {track}
        <p className="mt-8 text-center text-sm font-semibold text-slate-500">And many more</p>
      </div>
    </section>
  );
}
